/* eslint-disable prettier/prettier */
/* eslint-disable no-empty */
import 'react-toastify/dist/ReactToastify.css';
import { put, takeLatest, all, call } from 'redux-saga/effects';
import {
  SHOW_TOAST,
  SHOW_ERROR_TOAST,
  GET_BANNER_LIST,
  setBannerList,
  GET_FACTS_LIST,
  setFactsData,
  PING_SERVER,
  GET_POPUP_LIST,
  GET_WEB_BUILD_VERSION,
  setPopupData,
  setLastBuildCheckTime,
  SHOW_FEEDBACK_MODAL,
  showFeedbackModal
} from '../actions/app-actions-types';
import httpClient from './http-client';
import { toast } from 'react-toastify';
import axios from 'axios';
import Connection from '../utilities/Connection';

// function* getBaseUrlsObj({ payload: { callback } }) {
//   const payload = {
//     method: 'GET',
//     url: 'tenant',
//     module: 'admin'
//   }
//   const { result, error } = yield call(httpClient, payload, false)
//   callback({ result, error })
//   if (!error && result && result.apps) {
//     yield put(setBaseUrlsObj(result.apps))
//   }
// }

function* showToast(action) {
  if (!window?.ReactNativeWebView) {
    yield toast(action.payload);
  }
}

function* showErrorToast(action) {
  if (!window?.ReactNativeWebView) {
    yield toast(action.payload);
  }
}

function* getBannerList() {
  try {
    const imageUrl = Connection.getBannerUrl();
    const url = `${imageUrl}/banner.json`;
    const result = yield axios.get(url);

    const { data } = result;
    yield put(setBannerList(data));
  } catch (error) {}
}

function* getPopupList() {
  try {
    const imageUrl = Connection.getBannerUrl();
    const url = `${imageUrl}/popup.json`;
    const result = yield axios.get(url);
    const { data } = result;
    yield put(setPopupData(data));
  } catch (error) {}
}

function* getFactsList() {
  try {
    const imageUrl = Connection.getBannerUrl();
    const url = `${imageUrl}/sports_facts.json`;
    const result = yield axios.get(url);
    const { data } = result;
    yield put(
      setFactsData({
        lastCallingFactAPITime: new Date().getTime(),
        factsList: data
      })
    );
  } catch (error) {}
}

function* pingServer({ payload: { callback } }) {
  const payload = {
    method: 'GET',
    url: 'health'
  };

  const { result, error } = yield call(httpClient, payload, true);
  callback({ result, error });
}

function* getWebBuildVersion({ payload: { callback } }) {
  try {
    const payload = {
      method: 'GET',
      url: `${window.location.origin}/meta.json`,
      isCloudFrontURL: true,
      noCache: true
    };
    const { result, error } = yield call(httpClient, payload, false);
    callback({ result, error });
    if (!error) {
      yield put(setLastBuildCheckTime(new Date().getTime()));
    }
  } catch (error) {
    //
  }
}

function* showFeedback(action) {
  yield showFeedbackModal(action.payload);
}

function* app() {
  yield all([
    yield takeLatest(SHOW_TOAST, showToast),
    yield takeLatest(SHOW_ERROR_TOAST, showErrorToast),
    // yield takeLatest(GET_BASE_URLS_OBJ, getBaseUrlsObj),
    yield takeLatest(GET_BANNER_LIST, getBannerList),
    yield takeLatest(GET_POPUP_LIST, getPopupList),
    yield takeLatest(GET_FACTS_LIST, getFactsList),
    yield takeLatest(PING_SERVER, pingServer),
    yield takeLatest(GET_WEB_BUILD_VERSION, getWebBuildVersion),
    yield takeLatest(SHOW_FEEDBACK_MODAL, showFeedback)
  ]);
}

export default app;
